import Address from './Address';
import AddressProof from './AddressProof';
import EnrollmentAPI from './EnrollmentAPI';
import FiscalRegime from './FiscalRegime';
import Identification from './Identification';
import Status from './Status';
export { Address, AddressProof, FiscalRegime, Identification, Status };
export default EnrollmentAPI;
